
import { Vue, Component, Ref } from 'vue-property-decorator';
import { BrandService } from '@/services/brand_service';
import lazyInject from '@/di';
import AudioUpload from './AudioUpload.vue';
import moment from 'moment';
import CarService from '@/services/car.service';

@Component({
  components: {
    AudioUpload,
  },
})
export default class RecordingDrawer extends Vue {
  visible = false;

  title = '录音列表';

  @lazyInject(BrandService)
  brandService!: BrandService;

  @Ref('audioUpload')
  audioUpload!: AudioUpload;

  @lazyInject(CarService)
  carService!: CarService;

  labelCol = {
    span: 8,
  };

  wrapperCol = {
    span: 16,
  };

  labelAlign = 'right';

  labelWidth = '220px';

  autoComplete = 'off';

  barName = '';

  createTime: any = [];

  columns = [
    {
      title: '上传时间',
      dataIndex: 'created_at',
      key: 'created_at',
      align: 'center',
      width: 180,
    },
    {
      title: '被叫电话',
      dataIndex: 'calledPhone',
      key: 'calledPhone',
      align: 'center',
      width: 180,
    },
    {
      title: '上传人',
      dataIndex: 'userName',
      key: 'userName',
      align: 'center',
      width: 180,
    },
    {
      title: '录音时长',
      dataIndex: 'call_time',
      key: 'call_time',
      scopedSlots: { customRender: 'call_time' },
      align: 'center',
      width: 100,
      customRender: (text: any) => {
        if (!text) {
          return '--';
        }
        return `${Math.floor(text)}秒`;
      },
    },
    {
      title: '推送状态',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      width: 180,
    },
    {
      title: '操作',
      dataIndex: 'action',
      fixed: 'right',
      key: 'action',
      scopedSlots: { customRender: 'action' },
      align: 'center',
      width: 240,
    },
  ];

  statusList = [
    {
      label: '全部',
      value: '',
    },
    {
      label: '推送成功',
      value: '1',
    },
    {
      label: '推送中',
      value: '0',
    },
    {
      label: '推送失败',
      value: '-1',
    },
  ];

  dataSource: any = [];

  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    onChange: this.onChangePage,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
  };

  kaId = 0;

  form: any = {
    kaId: 0,
    page: 1,
    pageSize: 10,
    start_time: '',
    end_time: '',
    status: '',
  };

  onChangePage(page: any) {
    this.pagination.current = page;
    this.form.page = page;
    this.getAudioList(this.form);
  }
  onShowSizeChange(current: number, size: number) {
    this.pagination.current = current;
    this.pagination.pageSize = size;
    this.form.page = current;
    this.form.pageSize = size;
    this.getAudioList(this.form);
  }
  onChange(val: any) {
    if (!val.length) {
      this.form.start_time = null;
      this.form.end_time = null;
      return;
    }
    this.createTime = val;
    this.$set(this.form, 'start_time', moment(val[0]).format('YYYY-MM-DD'));
    this.$set(this.form, 'end_time', moment(val[1]).format('YYYY-MM-DD'));
  }
  open(row: any) {
    this.title = `录音列表 - ${row.name}`;
    this.form.kaId = row.id;
    this.barName = row.name;
    this.kaId = row.id;
    this.getAudioList(this.form);
    this.visible = true;
  }

  showDrawer() {
    this.visible = true;
  }

  uploadAudio() {
    this.audioUpload.open();
  }

  onSubmit() {
    this.getAudioList(this.form);
  }

  onReset() {
    this.form = {
      kaId: this.kaId,
      page: 1,
      pageSize: 10,
      name: '',
      status: '',
    };
    this.createTime = [];
    this.getAudioList(this.form);
  }

  async getAudioList(data: any) {
    const { page, pageSize, status, kaId, start_time, end_time } = data;
    const params: any = {
      page: page || 1,
      car_ka_id: kaId,
      pageSize: pageSize || 10,
    };
    if (status) {
      params.status = status;
    }
    if (start_time) {
      params.start_time = start_time;
    }
    if (end_time) {
      params.end_time = end_time;
    }
    const res = (await this.carService.getCarKaAudioList(params)) as any;
    this.dataSource = res.list;
    this.pagination.total = res.total;
  }

  async downloadAudio(url: any, fileName: any) {
    const response = await fetch(url);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(blobUrl);
  }

  onClose() {
    this.form = {
      kaId: this.kaId,
      page: 1,
      pageSize: 10,
      name: '',
      status: '',
    };
    this.visible = false;
    this.dataSource = [];
    this.pagination.total = 0;
    this.pagination.current = 1;
    this.pagination.pageSize = 10;
  }

  async pushAudio(row: any) {
    try {
      const res = (await this.carService.carKaAudioPush({
        audio_id: row.id,
      })) as any;
      if (res) {
        this.$message.success('操作成功');
        this.getAudioList(this.form);
      }
    } catch (error) {
      this.$message.error('操作失败');
    }
  }
}
